import { jsx } from "react/jsx-runtime";
import { Tooltip } from "../tooltip/index.js";
import AsyncButton from "./AsyncButton.js";
function DisableTooltipButton(props) {
    const { tooltip, placement = 'top', customNode } = props;
    const renderBtn = ()=>customNode ? customNode : /*#__PURE__*/ jsx(AsyncButton, {
            ...props,
            disabled: Boolean(tooltip) || props.disabled
        });
    return tooltip ? /*#__PURE__*/ jsx(Tooltip, {
        placement: placement,
        title: tooltip,
        children: renderBtn()
    }) : renderBtn();
}
export { DisableTooltipButton as default };
